import api from 'api';
import moment from 'moment';

export const THEMES_ASYNC_ACTION_START = 'THEMES_ASYNC_ACTION_START';
export const THEMES_ASYNC_ACTION_SUCCESS = 'THEMES_ASYNC_ACTION_SUCCESS';
export const THEMES_ASYNC_ACTION_ERROR = 'THEMES_ASYNC_ACTION_ERROR';
export const THEMES_RESET_STATE = 'THEMES_RESET_STATE';

const s3BucketURL = APP_CONFIG.s3BucketURL;

function themesAsyncActionStart() {
  return {
    type: THEMES_ASYNC_ACTION_START,
  };
}

function themesAsyncActionSuccess(data) {
  return {
    type: THEMES_ASYNC_ACTION_SUCCESS,
    data,
  };
}

function themesAsyncActionError(error) {
  return {
    type: THEMES_ASYNC_ACTION_ERROR,
    error,
  };
}

export function resetThemesState() {
  return {
    type: THEMES_RESET_STATE,
  };
}

export function getThemesAsyncByDate() {
  return (dispatch, getState) => {
    dispatch(themesAsyncActionStart());
    return api.request(`theme/list?date=${ moment().subtract(3, 'months').format('YYYY/MM/DD') }`, 'get')
    .then((data) => {
      dispatch(themesAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(themesAsyncActionError('Unable to get Themes'));
      throw (err);
    });
  };
}

export function getThemesAsyncByDateAndOccasion(date, isOccasion) {
	  return (dispatch, getState) => {
	    
	    dispatch(themesAsyncActionStart());
	    return api.request(`theme/list?date=${ date }&isOccasion=${ isOccasion }`, 'get')
	    .then((data) => {
	    	data.map((themesGraphicCategory) => {
    	  		themesGraphicCategory.imageURL = `${ s3BucketURL }`+'system/theme-images/'+themesGraphicCategory.typeItemTextKey+'.png';
    	  		themesGraphicCategory.iconURL = `${ s3BucketURL }`+'system/theme-icons/'+themesGraphicCategory.typeItemTextKey+'.png';
   		    });	
	      dispatch(themesAsyncActionSuccess(data));
	      return data;
	    })
	    .catch((err) => {
	      dispatch(themesAsyncActionError('Unable to get Themes'));
	      throw (err);
	    });
	  };
	}